import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';

interface IModal {
  children: ReactNode;
  contentLabel?: string;
  isOpen?: boolean;
  contentOverflow?: string;
  borderRadius?: string;
  inset?: string;
  margin?: string;
  maxHeight?: string | number;
  maxWidth?: string | number;
  minHeight?: string | number;
  minWidth?: string | number;
  height?: string;
  onRequestClose?: (event?: React.MouseEvent | React.KeyboardEvent) => void;
  onAfterOpen?: () => void;
  top?: string | number;
  transform?: string;
  zIndex?: number;
}

/** @deprecated - prefer `design-system/Dialog` */
export const Modal: React.FC<IModal> = ({
  children,
  contentLabel,
  isOpen,
  borderRadius = '8px',
  inset,
  margin = '5% auto 20px',
  contentOverflow = 'auto',
  maxHeight = 'inherit',
  maxWidth = '660px',
  minHeight,
  minWidth,
  height,
  onRequestClose,
  onAfterOpen,
  top = 0,
  transform,
  zIndex = 100000,
}) => {
  const style = {
    overlay: {
      position: 'fixed',
      overflow: 'auto',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },

    content: {
      padding: '0',
      background: '#fff',
      boxShadow: '0 10px 20px -10px rgba(0,0,0,.4)',
      border: 0,
      borderRadius,
      outline: 'none',
      maxWidth,
      maxHeight,
      minHeight,
      minWidth,
      height,
      WebkitOverflowScrolling: 'touch',
      bottom: 'auto',
      top,
      margin,
      overflow: contentOverflow,
      transform,
      // Needed since if we simply pass { inset }, when undefined, it resets
      // inset to "auto", when we want it to default to ReactModal's default
      ...(inset && { inset }),
    },
  };

  const appElement =
    typeof document === 'undefined' ? undefined : document?.querySelector?.('#__next') ?? undefined;

  return (
    <>
      <ReactModal
        appElement={appElement}
        contentLabel={contentLabel}
        isOpen={isOpen || false}
        onRequestClose={onRequestClose as $FIXME}
        onAfterOpen={onAfterOpen}
        style={style}
      >
        {children}
      </ReactModal>

      <style jsx global>{`
        .ReactModal__Content {
          transform: translateY(-16px);
          transition: transform 0.2s;
        }

        .ReactModal__Content--after-open {
          transform: translateY(0);
        }

        .ReactModal__Body--open {
          overflow-x: hidden !important;
          overflow-y: hidden !important;
        }
      `}</style>
    </>
  );
};
